import './genesys/style';
import FormStructure from './genesys/form_structure';

export default FormStructure;